var _path, _ellipse, _ellipse2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 333,
    viewBox: "0 0 148 333",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.5093 147.039L70.3569 149.024L42.0689 332.166L35 332L29.2213 330.182L57.5093 147.039Z",
    fill: "url(#paint0_linear_2251_3595)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 74,
    cy: 75,
    rx: 74,
    ry: 75,
    fill: "url(#paint1_radial_2251_3595)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.6159,
    cy: 51.7291,
    rx: 8.11248,
    ry: 12.8092,
    transform: "rotate(29.2361 48.6159 51.7291)",
    fill: "url(#paint2_radial_2251_3595)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2251_3595",
    x1: 42.7983,
    y1: 331.965,
    x2: 29.2872,
    y2: 329.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.154805,
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403068,
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.784447,
    stopColor: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9E9E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2251_3595",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.5 51.5) rotate(79.3628) scale(100.222 98.886)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF8D8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533484,
    stopColor: "#BB2827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF0B0A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2251_3595",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.6159 51.7291) rotate(90) scale(12.8092 8.11248)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.7f0ed24895c40e73d5f567c777daa539.svg";
export { ForwardRef as ReactComponent };